import React, { useState } from 'react';
import { FiHeadphones } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default function LogisticRiderLoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (loading) return;
    setLoading(true);
    setMessage('');
    setSuccess(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logistics/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      setMessage(data.message);
      setSuccess(data.success);
      setTimeout(() => setMessage(''), 2000);
      if (data.success && data.token) {
        localStorage.setItem('logisticsToken', data.token);
        navigate('/logistic-home', { state: { loginSuccess: data.message } });
      }
    } catch (err) {
      setMessage('An error occurred during login. Please try again later.');
      setSuccess(false);
      setTimeout(() => setMessage(''), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col items-center px-6 pt-12 pb-8 relative">
      {message && (
        <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg text-sm font-semibold animate-fadeInOut ${success ? 'bg-[#19C463] text-white' : 'bg-red-500 text-white'}`} style={{ minWidth: '220px', textAlign: 'center', letterSpacing: '0.5px' }}>
          {message}
        </div>
      )}
      {/* Logo */}
      <div className="mb-6">
        <img
          src="/BUY iT Logistic Logo.png"
          alt="BUY iT Logistic Logo"
          className="w-32 h-32 object-contain"
        />
      </div>

      {/* Title */}
      <h1 className="text-2xl font-black text-black text-center mb-4 tracking-tight">
        BUY iT Logistic Network
      </h1>

      {/* Subtitle */}
      <p className="text-sm text-black text-center mb-8 leading-relaxed px-4">
        Input your details to login to your logistic account
      </p>

      {/* Form */}
      <div className="w-full space-y-4 mb-6">
        {/* Email */}
        <div className="relative">
          <span className="absolute -top-2.5 left-3 bg-[#F1F3F2] px-1 text-sm text-black font-medium">
            Email
          </span>
          <input
            type="email"
            placeholder="Input your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#F1F3F2] border-2 border-black rounded-md px-4 py-3.5 text-sm text-black placeholder-gray-500 outline-none"
          />
        </div>

        {/* Password */}
        <div className="relative">
          <span className="absolute -top-2.5 left-3 bg-[#F1F3F2] px-1 text-sm text-black font-medium">
            Password
          </span>
          <input
            type="password"
            placeholder="Input your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#F1F3F2] border-2 border-black rounded-md px-4 py-3.5 text-sm text-black placeholder-gray-500 outline-none"
          />
        </div>
      </div>

      {/* Login Button */}
      <button
        onClick={handleLogin}
        disabled={loading}
        className={`w-full text-base font-bold py-3.5 rounded-md mb-6 active:opacity-90 ${loading ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-[#19C463] text-white'}`}
      >
        {loading ? 'Logging in...' : 'Login'}
      </button>

      {/* Login as fleet rider */}
      <p className="text-sm text-black text-center mb-4">
        Login as a <span className="text-[#19C463] font-medium">fleet rider</span>
      </p>

      {/* New user text */}
      <p className="text-sm text-black text-center mb-12 leading-relaxed px-4">
        New user? Create an <span className="text-[#19C463] font-medium">individual rider</span> account or a <span className="text-[#19C463] font-medium">fleet rider</span> account
      </p>

      {/* Contact customer care */}
      <div className="absolute bottom-8 right-6">
        <button className="bg-gray-400 text-white text-sm font-medium py-2 px-4 rounded-md flex items-center gap-2 active:opacity-90">
          <FiHeadphones size={16} />
          Contact customer care
        </button>
      </div>
    </div>
  );
}
